import React from 'react';
import PropTypes from 'prop-types';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { connect } from 'react-redux';
import { reduxForm, getFormValues, isInvalid, Field } from 'redux-form';

class ProductLocation extends React.Component {
    componentDidMount() {
        const {
            data,
            initialize,
        } = this.props;

        initialize({
            location_address: data.location_address,
        });
    }

    render() {
        const {
            handleSubmit,
            handleSubmitForm,
            invalid,
            pristine,
            submitting,
            translate,
        } = this.props;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.orders.fields.location_address') }
                                    name='location_address'
                                />
                            </Item>
                        </Row>

                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ pristine || submitting || invalid }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

ProductLocation.propTypes = {
    data: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        formValues: getFormValues(form)(state),
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.location_address) {
                errors.location_address = translate('forms.required');
            }

            return errors;
        },
    }),
);

export default enhance(ProductLocation);



// WEBPACK FOOTER //
// ./src/pages/products/productLocation/ProductLocation.js